var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.approvalStatus !== null)?_c('div',[_c('i-badge',{staticClass:"approval-badge",attrs:{"label":_vm.badgeProperties.label,"colour":_vm.badgeProperties.colour,"icon":_vm.badgeProperties.icon,"aria-label":_vm.badgeProperties.label.toLowerCase(),"has-leading-icon":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }